module.exports = __webpack_public_path__ + "static/media/comment-lines.32d38660.svg";